module.exports = __webpack_public_path__ + "img/locationicon.cd78529c.svg";